import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

export const RoomName = styled("span")(() => ({
  color: "#475467",
  font: "600 16px Manrope",
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

export const RoomInfoHeader = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignSelf: "stretch",
  alignItems: "center",
}));

export const RoomInfoText = styled("span")(() => ({
  color: "#475467",
  font: "400 12px Manrope",
  lineHeight: "16px",
  letterSpacing: "0.4px",
}));

export const RoomItemsInfo = styled("ul")(() => ({
  listStyle: "none",
  margin: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  "& li": {
    margin: 0,
    position: "relative",
    "&:not(:last-child)": {
      paddingRight: "12px",
      marginRight: "8px",
      "&:after": {
        content: "''",
        position: "absolute",
        width: 4,
        height: 4,
        top: "45%",
        right: 0,
        backgroundColor: "#475467",
        borderRadius: 4,
      },
    },
  },
}));

export const RoomItemsWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "12px",
  paddingTop: 12,
}));

export const RoomItemCard = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  borderRadius: "8px",
  border: "1px solid #E4E7EC",
  padding: "8px 16px",
  alignSelf: "stretch",
  gap: 14,
}));

export const ItemTitle = styled("span")(() => ({
  color: "#1D2939",
  font: "600 16px Manrope",
  lineHeight: "24px",
}));

export const ItemInfo = styled("span")(() => ({
  color: "#475467",
  font: "400 14px Manrope",
  lineHeight: "20px",
}));

export const ItemInfoText = styled("span")(() => ({
  color: "#475467",
  font: "600 14px Manrope",
  lineHeight: "20px",
}));

export const ItemInfoWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignSelf: "stretch",
  gap: "4px",
}));

const styles = makeStyles(() => ({
  badge: {
    height: 24,
    maxWidth: 148,
    borderRadius: 100,
    padding: "4px 12px",
    "& > span": {
      fontFamily: "Manrope",
      fontSize: 12,
      fontWeight: 600,
      lineHeight: "16px",
      letterSpacing: 0.5,
    },
  },
}));

export default styles;
